module.exports = __webpack_public_path__ + "static/media/logo.72f14a1b.png";